import { axios } from '@/services/axios';

export const updateSBC = (sbcData) => {
    return axios.put('/sessionbordercontroller/', sbcData);
};
